import { Pipe, PipeTransform } from '@angular/core';
import { JobDetailQuestions, JobFieldsToDisplayInJobDetails } from 'app/Modules/Job/Models/jobdetails.model';
import * as _ from 'lodash';

@Pipe({
  name: 'showJobDetailsFields'
})
export class ShowJobDetailsFieldsPipe implements PipeTransform {

  transform(aoFields: JobDetailQuestions[] | null | undefined, jobFieldsToDisplay: JobFieldsToDisplayInJobDetails | null | undefined, dynamicStrings?: any): JobDetailQuestions[] {
    if (!aoFields || !jobFieldsToDisplay) {
      return [];
    }
    const renderedFields: any[] = [];
    if (jobFieldsToDisplay.Position1 != null) {
        var jobPos1Field = _.find(aoFields, { 'VerityZone': jobFieldsToDisplay.Position1.toLowerCase() });
        if (jobPos1Field != undefined)
            renderedFields.push(jobPos1Field);
    }
    if (jobFieldsToDisplay.JobTitle != null) {
        var jobTitleField = _.find(aoFields, { 'VerityZone': jobFieldsToDisplay.JobTitle.toLowerCase() });
        if (jobTitleField != undefined)
            renderedFields.push(jobTitleField);
    }
    if (jobFieldsToDisplay.Position3 != null && jobFieldsToDisplay.Position3.length > 0) {
        _.each(jobFieldsToDisplay.Position3, function (value) {
            var jobPos3Field = _.find(aoFields, { 'VerityZone': value.toLowerCase() });
            if (jobPos3Field != undefined)
                renderedFields.push(jobPos3Field);
        });
    }
    if (jobFieldsToDisplay.Summary != null) {
        var jobDescritpionField = _.find(aoFields, { 'VerityZone': jobFieldsToDisplay.Summary.toLowerCase() });
        if (jobDescritpionField != undefined)
            renderedFields.push(jobDescritpionField);
    }
    if (jobFieldsToDisplay.Section2Fields != null && jobFieldsToDisplay.Section2Fields.length > 0) {
        _.each(jobFieldsToDisplay.Section2Fields, function (value) {
            var jobSection2Field = _.find(aoFields, { 'VerityZone': value.toLowerCase() });
            if (jobSection2Field != undefined)
                renderedFields.push(jobSection2Field);
        });
    }
    var position = 0;
    _.each(renderedFields, function (opt) {
        if (opt != null) {

            if (jobFieldsToDisplay.Position1 != null && opt.VerityZone == jobFieldsToDisplay.Position1.toLowerCase()) {
                opt.ClassName = "position1InJobDetails";
                opt.QuestionName = "";
            }
            else if (jobFieldsToDisplay.JobTitle != null && opt.VerityZone == jobFieldsToDisplay.JobTitle.toLowerCase()) {
                opt.ClassName = "jobtitleInJobDetails";
                opt.QuestionName = "";
            }
            else if (jobFieldsToDisplay.Position3 != null && jobFieldsToDisplay.Position3.length > 0 && jobFieldsToDisplay.Position3.indexOf(opt.VerityZone.toLowerCase()) >= 0) {
                opt.ClassName = "position3InJobDetails";
                opt.QuestionName = "";
            }
            else if (jobFieldsToDisplay.Summary != null && opt.VerityZone == jobFieldsToDisplay.Summary.toLowerCase()) {
                opt.ClassName = "jobdescriptionInJobDetails";
            }
            else if (jobFieldsToDisplay.Section2Fields != null && jobFieldsToDisplay.Section2Fields.length > 0 && jobFieldsToDisplay.Section2Fields.indexOf(opt.VerityZone.toLowerCase()) >= 0) {
                if (opt.QuestionType?.toLowerCase() == "textarea") {
                    opt.ClassName = "section2LeftfieldsInJobDetails jobDetailTextArea";
                    position = -1;
                }
                else {
                    if (opt.VerityZone != null && opt.VerityZone.toLowerCase() == "dateclosed") {
                        opt.QuestionName = dynamicStrings?.Lbl_RemovalDate || "Job Expires";
                    }
                    if (position % 2 == 0) {
                        opt.ClassName = "section2LeftfieldsInJobDetails";
                    }
                    else {
                        opt.ClassName = "section2RightfieldsInJobDetails";
                    }
                }
                position = ++position;
            }
        }
    });

    return renderedFields;
}
  }


